import { createClient } from '@bit/together-price.core.auth-client';
import SecureStorage from './storage';

const client = createClient(process.env.REACT_APP_UMS, {
  storage: SecureStorage,
});

export default client;
